import { compose, hoistStatics } from 'recompose';
import { translate } from 'react-i18next';
import Footer from './Footer';

const enhance = compose(
  translate('core'),
);

export default hoistStatics(enhance)(Footer);



// WEBPACK FOOTER //
// ./src/containers/footer/index.js